import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit, signal } from '@angular/core';

import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { WheelComponent } from '../../../wheel/wheel.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { noNewWheelNameValidator } from '../../../personal/wheel-name.validators';
import { NEW_WHEEL_NAME } from '../../../wheel/features/wheel-name-form/wheel-name-form.component';

@Component({
  selector: 'wil-create-wheel-modal',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    WheelComponent,
    MatFormFieldModule,
    MatInputModule
],
  templateUrl: './create-wheel-modal.component.html',
  styleUrls: ['./create-wheel-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CreateWheelModalComponent implements OnInit {
  private readonly dialogRef = inject(MatDialogRef<CreateWheelModalComponent>);
  private readonly fb = inject(FormBuilder);
  private readonly destroyRef = inject(DestroyRef);
  public readonly data = inject<{ wheelId: string; name: string }>(MAT_DIALOG_DATA);

  public readonly wheelForm = this.fb.group({
    title: [NEW_WHEEL_NAME, [Validators.required, Validators.minLength(1), Validators.maxLength(100), noNewWheelNameValidator()]],
  });

  public readonly isModified = signal(false);
  public wheelId;

  constructor() {
    this.wheelId = this.data.wheelId;
    this.wheelForm.controls.title.patchValue(this.data.name);
  }

  ngOnInit(): void {
    // Watch for form changes
    this.wheelForm.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.isModified.set(true);
    });
  }

  private getRandomColor(): string {
    const colors = ['#ff6b6b', '#4ecdc4', '#45b7d1', '#f9ca24', '#6c5ce7', '#a29bfe', '#fd79a8', '#00cec9'];
    return colors[Math.floor(Math.random() * colors.length)];
  }

  public onCancel(): void {
    if (this.isModified()) {
      // TODO: Add confirmation dialog for unsaved changes
      const confirmDiscard = confirm('You have unsaved changes. Are you sure you want to discard them?');
      if (!confirmDiscard) {
        return;
      }
    }

    this.dialogRef.close({ action: 'cancel' });
  }
}
